import React, { ComponentProps } from 'react'
import Switch, { switchClasses } from '@mui/material/Switch'

const width = '40px'
const height = '24px'
const thumbSize = '16px'
const gap = '4px'

export const Toggle = ({ sx, ...props }: ComponentProps<typeof Switch>) => {
    return (
        <Switch
            {...props}
            disableRipple
            sx={[
                (theme) => ({
                    width,
                    height,
                    padding: 0,
                    margin: theme.spacing(1),
                    overflow: 'unset',
                    [`& .${switchClasses.switchBase}`]: {
                        padding: gap,
                        [`& .${switchClasses.input}`]: {
                            left: 0,
                            width,
                        },
                        [`&.${switchClasses.checked}`]: {
                            transform: `translateX(${thumbSize})`,
                            [`& + .${switchClasses.track}`]: {
                                backgroundColor: theme.palette.figma.primary,
                                opacity: 1,
                            },
                            [`& .${switchClasses.thumb}`]: {
                                backgroundColor: theme.palette.figma.accentColors.white,
                            },
                            [`& .${switchClasses.input}`]: {
                                left: '-' + thumbSize,
                            },
                        },
                        '&:hover': {
                            backgroundColor: 'transparent',
                            [`& + .${switchClasses.track}`]: {
                                opacity: 0.8,
                            },
                        },
                    },
                    [`& .${switchClasses.thumb}`]: {
                        boxShadow: 'none',
                        backgroundColor: theme.palette.figma.accentColors.white,
                        width: thumbSize,
                        height: thumbSize,
                    },
                    [`& .${switchClasses.track}`]: {
                        border: 'none',
                        borderRadius: 40,
                        backgroundColor: theme.palette.figma.grayscale.tier5,
                        opacity: 1,
                        boxSizing: 'border-box',
                    },
                }),
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        />
    )
}
